// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__container__jJJYq {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__dropdown-filter-options__A3XxF {
  margin-bottom: 0px !important;
  margin-left: 1rem;
}
.index-module__filter-LastNDays__UXd7U {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 7px;
  width: auto;
}
/* Base styles for the filter options */
.index-module__filter-option__s22dM {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  border: 1px solid gray;
  background-color: #ffffff;
  cursor: pointer;
  /* Removed quotes */
  transition: all 0.3s ease;
  /* Smooth transition for hover effect */
}
.index-module__filter-option__s22dM:hover {
  color: #fff !important;
  border: 1px solid var(--app-secondary-color) !important;
  /* Replace with your secondary color */
  background: var(--app-secondary-color) !important;
  /* Replace with your secondary color */
}
.index-module__filter-option-selected__XLwYU {
  background-color: var(--app-primary-color);
  /* Replace with your primary color */
  border-color: var(--app-primary-color);
  /* Replace with your primary color */
  color: #fff;
}
.index-module__filter-option-not-selected__kJyOD {
  cursor: pointer !important;
}
.index-module__button__pKG2X {
  min-width: 50px;
  margin: 5px;
}
.index-module__selectedButton__q7BeF {
  background-color: var(--app-primary-color);
  color: white;
  border: none;
}
.index-module__datePickerSpace__ngRk6 {
  width: 100%;
}
.index-module__datePicker__T2eP7 {
  width: 100%;
}
.index-module__monthSelect__3kkqr {
  width: 200px;
}
/* Dropdown button style */
.index-module__ant-btn__lQGH2 {
  margin-left: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/MultiFunctionDateFilter/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,sCAAsC;EACtC,iDAAiD;EACjD,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.dropdown-filter-options {\n  margin-bottom: 0px !important;\n  margin-left: 1rem;\n}\n.filter-LastNDays {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 7px;\n  width: auto;\n}\n/* Base styles for the filter options */\n.filter-option {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  border: 1px solid gray;\n  background-color: #ffffff;\n  cursor: pointer;\n  /* Removed quotes */\n  transition: all 0.3s ease;\n  /* Smooth transition for hover effect */\n}\n.filter-option:hover {\n  color: #fff !important;\n  border: 1px solid var(--app-secondary-color) !important;\n  /* Replace with your secondary color */\n  background: var(--app-secondary-color) !important;\n  /* Replace with your secondary color */\n}\n.filter-option-selected {\n  background-color: var(--app-primary-color);\n  /* Replace with your primary color */\n  border-color: var(--app-primary-color);\n  /* Replace with your primary color */\n  color: #fff;\n}\n.filter-option-not-selected {\n  cursor: pointer !important;\n}\n.button {\n  min-width: 50px;\n  margin: 5px;\n}\n.selectedButton {\n  background-color: var(--app-primary-color);\n  color: white;\n  border: none;\n}\n.datePickerSpace {\n  width: 100%;\n}\n.datePicker {\n  width: 100%;\n}\n.monthSelect {\n  width: 200px;\n}\n/* Dropdown button style */\n.ant-btn {\n  margin-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container__jJJYq`,
	"dropdown-filter-options": `index-module__dropdown-filter-options__A3XxF`,
	"filter-LastNDays": `index-module__filter-LastNDays__UXd7U`,
	"filter-option": `index-module__filter-option__s22dM`,
	"filter-option-selected": `index-module__filter-option-selected__XLwYU`,
	"filter-option-not-selected": `index-module__filter-option-not-selected__kJyOD`,
	"button": `index-module__button__pKG2X`,
	"selectedButton": `index-module__selectedButton__q7BeF`,
	"datePickerSpace": `index-module__datePickerSpace__ngRk6`,
	"datePicker": `index-module__datePicker__T2eP7`,
	"monthSelect": `index-module__monthSelect__3kkqr`,
	"ant-btn": `index-module__ant-btn__lQGH2`
};
export default ___CSS_LOADER_EXPORT___;
